<template lang="pug">
  .mass-changes-wrapper
    h2 alterações rápidas

    PDatePicker(
      name="date"
      label="selecionar período"
      v-model="period"
      :range="true"
    )

    RadioSlider.slider(
      :items="categories.items",
      :current="categories.items.findIndex(i => i.id === categories.selected.id)",
      @selected="onSelectOption"
    )

    .employees
      PMultiSelect(
        ref="itemSelector"
        labelItem="name"
        v-model="$data[categories.selected.vmodel]"
        :title="categories.selected.name"
        :useState="categories.selected.useState"
        :useCommon="categories.selected.common"
        :disabled="!categories.selected"
        :usaPaginacao="usaPaginacao"
      )

    .flex
      Accordion(:startOpen="true" v-if="optionsGrouped.justifies.length")
        template(slot="heading")
          | justificativas
        template
          Justifies(:saveParams="saveParams", :options="optionsGrouped.justifies")

      Accordion(:startOpen="false" v-if="optionsGrouped.pontos.length")
        template(slot="heading")
          | pontos
        Pontos(:saveParams="saveParams", :options="optionsGrouped.pontos")

      Accordion(:startOpen="false" v-if="optionsGrouped.bh.length")
        template(slot="heading")
          | banco de horas
        BH(:saveParams="saveParams", :options="optionsGrouped.bh")

      Accordion(:startOpen="false" v-if="optionsGrouped.journeys.length")
        template(slot="heading")
          | jornada
        Journeys(:saveParams="saveParams", :options="optionsGrouped.journeys")

      Accordion(:startOpen="false"  v-if="optionsGrouped.opcoesAvancadas.length")
        template(slot="heading")
          | opções avançadas
        AdvancedOptions(:saveParams="saveParams", :options="optionsGrouped.opcoesAvancadas")

</template>

<script>
import Justifies from './options/Justifies'
import Pontos from './options/Pontos'
import BH from './options/BH'
import Journeys from './options/Journeys'
import AdvancedOptions from './options/AdvancedOptions'
import {formatDateToSend} from 'src/utils'

export default {
  name: 'MassChanges',
  created () {
    this.options = this.options.filter(({permission}) => this.$hasPermission(permission))
  },
  components: {Journeys, BH, Justifies, Pontos, AdvancedOptions},
  data () {
    return {
      period: { start: new Date(), end: new Date() },
      categories: {
        selected: { name: this.$wp('employee'), id: 'employee', common: 'employees/onlyNotFired', vmodel: 'employees' },
        items: [
          { name: this.$wp('companyShortName'), id: 'company', common: 'companies/onlyActive', vmodel: 'companies' },
          { name: this.$wp('employee'), id: 'employee', common: 'employees/onlyNotFired', vmodel: 'employees' },
          { name: this.$wp('employer'), id: 'employer', common: 'employers', vmodel: 'employers' }
        ]
      },
      employees: { selected: [] },
      companies: { selected: [] },
      employers: { selected: [] },
      options: [
        {id: 'justify', name: 'adicionar dispensa', permission: {module: 'justify', action: 'post'}},
        {id: 'justified_absence', name: 'adicionar observação', permission: {module: 'justify', action: 'post'}},
        {id: 'delete_abstract_justify', name: 'remover dispensas, suspensões e observações', permission: {module: 'justify', action: 'delete'}},
        {id: 'whb_closer', name: 'baixa de bh', permission: {module: 'workhourbankcloser', action: 'post'}},
        {id: 'suspension', name: 'adicionar suspensão', permission: {module: 'suspension', action: 'post'}},
        {id: 'journey', name: 'alterar ' + this.$ws('journey'), permission: {module: 'dayjourney', action: 'post'}},
        {id: 'faketimelog', name: 'adicionar ponto correção', permission: {module: 'faketimelog', action: 'post'}},
        {id: 'delete_faketimelog', name: 'apagar pontos do autocompletar', permission: {module: 'faketimelog', action: 'delete'}},
        {id: 'vacation', name: 'adicionar férias', permission: {module: 'dayjourney', action: 'post'}},
        {id: 'delete_all_faketimelogs', name: 'apagar todos os pontos manuais', permission: {module: 'faketimelog', action: 'post'}},
        {id: 'add_activity', name: 'lançar atividade', permission: {module: 'activityline', action: 'post'}},
        {id: 'auto_correct_activity', name: 'autocorreção de atividade', permission: {module: 'activityline', action: 'post'}},
        {id: 'disregard_holiday', name: 'desconsiderar horas extras de feriado', permission: {module: 'line', action: 'post'}},
        {id: 'force_non_pause', name: 'desconsiderar pausa', permission: {module: 'line', action: 'post'}},
        {id: 'recalculate', name: 'recalcular', permission: {module: 'line', action: 'post'}},
        {id: 'add_autocomplete', name: 'auto-completar', permission: {module: 'autocomplete', action: 'post'}}
      ]
    }
  },
  computed: {
    usaPaginacao () { return this.categories.selected.id === 'employee' },
    optionsGrouped () {
      return {
        justifies: this.options.filter(i => {
          return ['justify', 'suspension', 'justified_absence', 'delete_abstract_justify'].includes(i.id)
        }),
        pontos: this.options
          .filter(i => ['delete_faketimelog', 'delete_all_faketimelogs', 'faketimelog', 'add_autocomplete'].includes(i.id)),
        bh: this.options.filter(i => ['remove_whb_closer', 'whb_closer'].includes(i.id)),
        journeys: this.options.filter(i => ['vacation', 'journey'].includes(i.id)),
        opcoesAvancadas: this.options.filter(i => ['disregard_holiday', 'recalculate', 'force_non_pause'].includes(i.id))
      }
    },
    saveParams () {
      return {
        startDate: formatDateToSend(this.period.start),
        endDate: formatDateToSend(this.period.end),
        employees: this.employees.selected.map(i => i.id),
        employer: this.employers.selected.map(i => i.id),
        // TODO make api accept companies
        companies: this.companies.selected.map(i => i.id)
      }
    }
  },
  methods: {
    onSelectOption (item) {
      this.categories.selected = item
      this.$refs.itemSelector.open()
    }
  }
}
</script>

<style scoped lang="scss">
.mass-changes-wrapper {
  display: grid;
  grid-template-columns: 250px 1fr 1fr;
  grid-column-gap: 10px;
  margin-bottom: 30px;

  h2 {
    grid-column: 1/4;
    text-align: center;
  }

  .employees {
    grid-column: 3/4;
  }

  .slider {
    align-self: flex-end;
    margin-bottom: 13px;
  }

  .option {
    grid-row: 3;
    grid-column: 1/4;
  }

  .flex {
    display: grid;
    margin-top: 30px;
    grid-column: 1/4;
    grid-column-gap: 30px;
    grid-row-gap: 30px;
    grid-template-columns: 1fr;
  }
}
</style>
